module.exports = __webpack_public_path__ + "img/logo.46235947.svg";